export const getFormattedPrice = (price: number | string, currency: string = 'USD'): string => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
    });

    const value = formatter.format(!!price && !isNaN(+price) ? +price : 0);

    return value.replace('.00', '');
};
